import type { InputHTMLAttributes } from 'react';

type InputProps = InputHTMLAttributes<HTMLInputElement> & {
    post?: string;
};

export function Input({ className = '', post = '', ...props }: InputProps) {
    const color = 'bg-background text-foreground outline-muted';

    return (
        <>
            <input {...props} className={`block w-full rounded-xs ${post && 'rounded-r-none'} placeholder:opacity-50 px-3 py-2 leading-1 font-thin outline focus:ring-4 ring-primary/50 disabled:opacity-50 disabled:cursor-not-allowed disabled:pointer-events-none ${color} ${className}`} />
            {!!post && <div className="h-full flex items-center px-3 py-0 border border-l-0 border-muted rounded-r-sm bg-muted/50 text-sm font-thing">{post}</div>}
        </>
    );
}
